import { ActionIcon, useMantineColorScheme, Tooltip } from "@mantine/core";
import { IconSun, IconMoon } from "@tabler/icons-react";
import {
  translateIdentity,
  type StaticTextTranslator,
} from "@/utils/staticTextTranslator";
import styles from "./ThemeToggle.module.css";

/**
 * Toggle button for switching between light and dark color schemes
 */
interface ThemeToggleProps {
  translate?: StaticTextTranslator;
}

export const ThemeToggle = ({
  translate = translateIdentity,
}: ThemeToggleProps) => {
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  const toggleColorScheme = () => {
    setColorScheme(colorScheme === "dark" ? "light" : "dark");
  };

  const isDark = colorScheme === "dark";
  const label = isDark
    ? translate("Switch to light mode")
    : translate("Switch to dark mode");

  return (
    <Tooltip label={label}>
      <ActionIcon
        className={styles.toggle}
        variant="subtle"
        size="lg"
        onClick={toggleColorScheme}
        aria-label={label}
      >
        {isDark ? <IconSun size={20} /> : <IconMoon size={20} />}
      </ActionIcon>
    </Tooltip>
  );
};
